import {
  Box,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdOutlineShoppingCart, MdOutlinePersonOutline } from 'react-icons/md';
import { FaBagShopping } from 'react-icons/fa6';
import { Desktop, Mobile } from '../visual';
import ProfilePopup from './profile-popup';
import { useContext, useState } from 'react';
import LoginModal from '../login';
import { CartContext } from '@/app/cart/context/cart';
import Badge from '../badge';
import goftino from '@/utils/goftino';
import logger from '@/service/tracking/ecommerce';
import { IoChevronBack } from 'react-icons/io5';
import { device } from '@/utils/helpers/device';
import { shouldShowBackButton } from '@/router';
import { useIsMobileOrTablet } from '@/hooks/use-media-query';

export function IOSBackButton() {
  const navigate = useNavigate();
  const isSmallScreen = useIsMobileOrTablet();

  if (
    !isSmallScreen ||
    !device.isIOS ||
    (typeof window !== 'undefined' && window.history.length <= 1) ||
    !shouldShowBackButton(window.location.pathname)
  )
    return null;

  return (
    <IconButton
      aria-label="بازگشت"
      icon={<IoChevronBack size={18} />}
      zIndex={10}
      bg="white"
      borderRadius="full"
      border="1px solid black"
      onClick={() => navigate(-1)}
      size="sm"
      mr={3}
    />
  );
}

function Actions() {
  const navigate = useNavigate();
  const location = useLocation();
  const disclosure = useDisclosure();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const { cart } = useContext(CartContext);
  return (
    <Stack
      mr="auto"
      direction={{ base: 'row-reverse', md: 'row' }}
      align={'center'}
    >
      <IOSBackButton />
      <Badge content={cart?.items.length}>
        <IconButton
          onClick={() => {
            if (location.pathname !== '/cart') navigate('/cart');
          }}
          aria-label="cart button"
          borderRadius={'full'}
          fontSize={'xl'}
          bgColor={{ base: 'gray.50', md: 'blackAlpha.100' }}
          color={{ base: 'black', md: 'blackAlpha.700' }}
        >
          <Box>
            <Desktop>
              <MdOutlineShoppingCart />
            </Desktop>
            <Mobile>
              <FaBagShopping size="20" />
            </Mobile>
          </Box>
        </IconButton>
      </Badge>
      <Popover {...disclosure} placement="bottom-end">
        <PopoverTrigger>
          <IconButton
            aria-label="profile button"
            borderRadius={'full'}
            fontSize={'xl'}
            bgColor={{ base: 'gray.50', md: 'blackAlpha.100' }}
            color={{ base: 'black', md: 'blackAlpha.700' }}
          >
            <MdOutlinePersonOutline size="22" />
          </IconButton>
        </PopoverTrigger>
        <PopoverContent
          filter={
            'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.06)) drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.10))'
          }
          border={'none'}
          pt={1}
          pb={3}
          px={1}
          ml={4}
          maxW={'290px'}
        >
          <PopoverBody>
            <ProfilePopup
              onLogin={() => {
                setIsLoginOpen(true);
                goftino.close();
              }}
              onClose={() => disclosure.onClose()}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
      <LoginModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onLogin={() => logger.login()}
      />
    </Stack>
  );
}

export default Actions;
